export default "__VITE_ASSET__8wh3vQdx__"